import styled from "styled-components";
import { theme } from "@themes";

export const ContentModal = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentModalActiveSurvey = styled.div`
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  max-width: 483px;
  height: 299px;
  width: 80%;

  input {
    padding: 0.5em;
    width: 60%;
    border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
    outline: 0;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    color: ${({ theme }) => theme.primaryIconColor};
  }

  input::placeholder {
    font-size: 12px;
  }
`;

export const CloseModalActiveSurvey = styled.div`
  height: 51px;
  width: 100%;
  text-align: end;
  padding: 0.5em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.primaryColorDark};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModalActiveSurvey = styled.div`
  padding: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  text-align: center;
  height: 180px;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    font-size: 16px;
    color: ${({ theme }) => theme.neutral.black};
    font-weight: 400;
    height: auto;
  }

  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ButtonActiveSurvey = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 98px;
  height: 37px;
    background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:hover {
    background-color: rgba(46, 46, 46, 1);
  }
`;
export const ButtonActiveSurveyCancel = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 98px;
  height: 37px;
  background: white;
  border-radius: 4px;
  border: 1px solid;
  margin: 0 10px;
  color: ${({ theme }) => theme.button.primary};
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;
export const ActionButtons = styled.div`
  height: 66px;
  display: flex;
  margin: auto;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
`;
